import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "row mt-4 mb-4" }

import { ref } from "vue";
    import BrightcoveVideo from "@/guiide/components/common/BrightcoveVideo.vue";
    import Modal from "@/guiide/components/common/Modal.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BrightcoveVideoModal',
  props: {
        accountId: { type: String, required: true },
        videoId: { type: String, required: true },
        linkText: { type: String, required: true },
        linkAriaLabel: { type: String, required: true },
        modalVideoAriaLabel: { type: String, required: true },
        modalTitle: { type: String, required: true }
    },
  setup(__props) {

    const props = __props;

    const brightcoveVideoModal = ref<HTMLElement>(null);
    const showBrightcoveVideo = ref<HTMLElement>(null);
    const isVideoModalVisible = ref(false);

    function openBrightcoveVideoModal() {
        isVideoModalVisible.value = true;
        brightcoveVideoModal.value.showModal();
    }

    function onBrightcoveVideoModalClosed() {
        isVideoModalVisible.value = false;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "",
      ref_key: "showBrightcoveVideo",
      ref: showBrightcoveVideo,
      onClick: _withModifiers(openBrightcoveVideoModal, ["prevent"]),
      onKeydown: _withKeys(openBrightcoveVideoModal, ["enter"]),
      tabindex: "0",
      "aria-label": __props.linkAriaLabel
    }, _toDisplayString(__props.linkText), 41, _hoisted_1),
    _createVNode(Modal, {
      ref_key: "brightcoveVideoModal",
      ref: brightcoveVideoModal,
      idKey: "brightcoveVideo",
      title: __props.modalTitle,
      returnFocusTo: showBrightcoveVideo.value,
      customStyles: "--bs-modal-width: 1000px;",
      onClosed: onBrightcoveVideoModalClosed
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (isVideoModalVisible.value)
            ? (_openBlock(), _createBlock(BrightcoveVideo, {
                key: 0,
                accountId: __props.accountId,
                videoId: __props.videoId,
                ariaLabel: __props.modalVideoAriaLabel
              }, null, 8, ["accountId", "videoId", "ariaLabel"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "returnFocusTo"])
  ], 64))
}
}

})